import { Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { HIERARCHY_BORDER_STYLE } from './styles';
import useDebounce from '../../../utils/useDebounce';

const HierarchyConnectorHorizontal = ({ anchorRef, verticalRef }) => {
    const [connectorWidth, setConnectorWidth] = useState(12);

    const updateConnectorWidth = useCallback(() => {
        if (!anchorRef?.current || !verticalRef?.current) return;

        const anchorRect = anchorRef.current.getBoundingClientRect();
        const verticalRect = verticalRef.current.getBoundingClientRect();

        // Calculate the distance from the anchor's left edge to the vertical line
        const anchorLeft = anchorRect.left;
        const verticalLineX = verticalRect.left;

        // The connector should extend from the anchor to the vertical line
        const width = Math.max(0, anchorLeft - verticalLineX);

        setConnectorWidth(width);
    }, [anchorRef, verticalRef]);

    const debouncedUpdateConnectorWidth = useDebounce(updateConnectorWidth, 10);

    useEffect(() => {
        // Update on mount and window resize
        updateConnectorWidth();

        // Use ResizeObserver to watch for element size changes
        const resizeObserver = new ResizeObserver(() => {
            debouncedUpdateConnectorWidth();
        });
        if (anchorRef?.current) resizeObserver.observe(anchorRef.current);
        if (verticalRef?.current) resizeObserver.observe(verticalRef.current);

        window.addEventListener('resize', debouncedUpdateConnectorWidth);
        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', debouncedUpdateConnectorWidth);
        };
    }, [updateConnectorWidth, debouncedUpdateConnectorWidth]);

    return (
        <Box
            aria-hidden
            sx={{
                position: 'absolute',
                top: 'calc(50% )',
                left: -connectorWidth,
                transition: 'width 0.2s ease-in-out',
                width: connectorWidth + 3,
                height: 0,
                borderTop: HIERARCHY_BORDER_STYLE,
                transform: 'translateY(-50%)',
            }}
        />
    );
};

export default HierarchyConnectorHorizontal;
